import type { InspectionLastHistory } from '@/types/deviceReport.types';
import * as styled from '@/components/inspectionHistory/LastEditedHistory/style';

interface Props extends InspectionLastHistory {
  size?: 'small' | 'large';
  layout?: 'horizontal' | 'vertical';
}

const LastEditedHistoryText = ({
  workerName,
  updatedAt,
  inspectionTime,
  size = 'large',
  layout = 'horizontal',
}: Props) => {
  // Use inspectionTime if available, otherwise fallback to updatedAt
  const displayTime = inspectionTime || updatedAt;
  
  return (
    <>
      {workerName && displayTime && (
        <styled.LastHistoryWrapper size={size} layout={layout}>
          {workerName && <styled.LastEditor layout={layout}>{workerName}</styled.LastEditor>}
          <styled.TimeElement>{displayTime}</styled.TimeElement>
        </styled.LastHistoryWrapper>
      )}
    </>
  );
};

export default LastEditedHistoryText;
